module.exports = __webpack_public_path__ + "static/media/reports.1760612e.svg";